var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "on-clickaway",
          rawName: "v-on-clickaway",
          value: _vm.reset,
          expression: "reset"
        }
      ]
    },
    [
      _c(
        "ul",
        { staticClass: "d-flex align-center" },
        _vm._l(_vm.filteredActivity, function(activities, activitiesIndex) {
          return _c(
            "li",
            {
              key: activitiesIndex,
              staticClass: "mr-3",
              class: {
                opacity:
                  _vm.isActive !== activities.state && _vm.isActive !== null
              },
              staticStyle: { "list-style": "none" },
              on: {
                click: function($event) {
                  return _vm.getState(activities)
                }
              }
            },
            [
              activities.state === "created" ||
              activities.state === "scheduled" ||
              activities.state === "company_assign"
                ? _c(
                    "div",
                    {
                      staticClass: "d-flex flex-row align-center",
                      staticStyle: { width: "100%" }
                    },
                    [
                      _c("task-state-icon", {
                        attrs: { state: activities.state }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "font" }, [
                        _vm._v(
                          _vm._s(_vm.numberOfActivityStates(activities.state))
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              activities.state === "in_progress"
                ? _c(
                    "div",
                    { staticClass: "d-flex flex-row align-center" },
                    [
                      _c("task-state-icon", {
                        attrs: { state: activities.state }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "font" }, [
                        _vm._v(
                          _vm._s(_vm.numberOfActivityStates(activities.state))
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              activities.state === "blocked"
                ? _c(
                    "div",
                    { staticClass: "d-flex flex-row align-center" },
                    [
                      _c("task-state-icon", {
                        attrs: { state: activities.state }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "font" }, [
                        _vm._v(
                          _vm._s(_vm.numberOfActivityStates(activities.state))
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              activities.state === "completed" ||
              activities.state === "approved"
                ? _c(
                    "div",
                    { staticClass: "d-flex flex-row align-center" },
                    [
                      _c("task-state-icon", {
                        attrs: { state: activities.state }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "font" }, [
                        _vm._v(
                          _vm._s(_vm.numberOfActivityStates(activities.state))
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              activities.state === "pending_approval"
                ? _c(
                    "div",
                    { staticClass: "d-flex flex-row align-center" },
                    [
                      _c("task-state-icon", {
                        attrs: { state: activities.state }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "font" }, [
                        _vm._v(
                          _vm._s(_vm.numberOfActivityStates(activities.state))
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              activities.state === "reopened"
                ? _c(
                    "div",
                    { staticClass: "d-flex flex-row align-center" },
                    [
                      _c("task-state-icon", {
                        attrs: { state: activities.state }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "font" }, [
                        _vm._v(
                          _vm._s(_vm.numberOfActivityStates(activities.state))
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3fd30711", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fd30711","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/WorkOrderForm/_Organisms/ActivityTasksState.vue
// module id = null
// module chunks = 